import { Template } from "./Template"
const buttonUrl = import.meta.env.VITE_GETTING_STARTED_BUTTON_URL;
export const GetStartedTemplate = ({serialCode}: {serialCode?: string}) => {
    const customContent = (
        <>
            <h1 className="text-h010-gradient text-5xl font-bold text-center mb-4">
                Welcome to the H010 Authenticator App!
            </h1>
            <p className="text-center text-lg mt-4">
                Now that you&apos;ve scanned your first QR code, you&apos;re ready to create a campaign
                and customise what your users would see on this screen. Just hit the button below
                and begin your journey today.
            </p>
        </>
    )

    return (
        <Template
            customContent={customContent}
            buttonText="Go to Dashboard"
            buttonUrl={buttonUrl}
            serialCode={serialCode} />
    )
}